import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const UrgentTicker = () => {
  const [latestNotice, setLatestNotice] = useState(null);

  useEffect(() => {
    const fetchNotices = async () => {
      try {
        // Fetch from LOCALHOST (or your .env URL)
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/notices`);
        const data = await response.json();
        
        // Logic: Find the first 'Urgent' notice. If none, take the very first one (newest).
        if (data.length > 0) {
            setLatestNotice(data[0]);
        }
      } catch (error) {
        console.error("Error fetching notices");
      }
    };
    fetchNotices();
  }, []);

  if (!latestNotice) return null; // Hide if nothing to show

  const isUrgent = latestNotice.type === 'Urgent';

  return (
    <div className={`w-100 py-2 text-center ${isUrgent ? 'bg-danger text-white' : 'bg-warning text-dark'}`}>
      <div className="container d-flex justify-content-center align-items-center">
        
        {/* Blinking Icon for Urgent */}
        {isUrgent && <i className="bi bi-exclamation-triangle-fill me-2 fa-fade"></i>}
        {!isUrgent && <i className="bi bi-bell-fill me-2"></i>}

        <span className="fw-bold me-2">
            {isUrgent ? 'URGENT UPDATE:' : 'LATEST NEWS:'}
        </span>
        
        <span className="me-3">
            {latestNotice.title} - {latestNotice.message.substring(0, 60)}...
        </span>

        <Link to="/notices" className={`btn btn-sm ${isUrgent ? 'btn-outline-light' : 'btn-dark'} ms-3`}>
            Read More
        </Link>

      </div>
    </div>
  );
};

export default UrgentTicker;